import React, { useState, useEffect, useContext } from "react";
import { Tabs, Tab, Box, Card, CardContent } from "@mui/material";
import PatientMapRosterTable from "../Table/PatientMapRosterTable";
import { PatientMapContext } from "../../../../context/PatientContext/PatientMapContext";


const PatientMapTabs = ({ onSelectPatient }) => {
  const [tab, setTab] = useState(0);

    const {
    patientMap,
    total,
    loading,
    page,
    setPage,
    pageSize,
    setPageSize,
    fetchData,
    fetchNewMembers,
    fetchAcaAging62To65,
    fetchAcaAging65Plus,
    } = useContext(PatientMapContext);

    const fetchByTab = async (tabIndex) => {
    switch (tabIndex) {
        case 0:
        await fetchData();
        break;
        case 1:
        await fetchNewMembers();
        break;
        case 2:
        await fetchAcaAging62To65();
        break;
        case 3:
        await fetchAcaAging65Plus();
        break;
        default:
        await fetchData();
    }
    };

  useEffect(() => {
    fetchByTab(tab);
  }, [tab, page, pageSize]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setPage(0); // Reset paginación al cambiar de tab
  };

  return (
    <Box>
      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="General Roster" />
        <Tab label="New Members" />
        <Tab label="ACA Aging 62–65" />
        <Tab label="ACA Aging 65+" />
      </Tabs>

      <Card sx={{ height: '760px', width: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 0 }}>
          <Box>
            <PatientMapRosterTable
              data={patientMap}
              loading={loading}
              total={total}
              page={page}
              pageSize={pageSize}
              setPage={setPage}
              setPageSize={setPageSize}
              onSelectPatient={onSelectPatient}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PatientMapTabs;